/* ============================================================================
   Brightside Landing — client-side behavior
   - Flavor switcher: swaps copy, images, notes, CTA links; mirrors to #hash
   - Sticky ATC bar: shows when main buy box leaves viewport
   - Email capture: inline toast on submit
   ============================================================================ */

(function () {
  'use strict';

  // ---- Flavor data is injected per-page via <script type="application/json" id="bs-flavors">
  function readFlavors() {
    var el = document.getElementById('bs-flavors');
    if (!el) return null;
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; }
  }

  var FLAVORS = readFlavors();
  if (!FLAVORS) return;

  var state = { flavor: Object.keys(FLAVORS)[0] };

  function setFlavor(key, pushHash) {
    if (!FLAVORS[key]) return;
    state.flavor = key;
    var f = FLAVORS[key];
    var root = document.querySelector('.bs-landing') || document.body;
    root.setAttribute('data-flavor', key);

    document.querySelectorAll('.bs-flav [data-flav]').forEach(function (b) {
      var active = b.getAttribute('data-flav') === key;
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (active) { b.setAttribute('aria-current', 'page'); } else { b.removeAttribute('aria-current'); }
    });

    document.querySelectorAll('[data-bs-dyn]').forEach(function (n) {
      var k = n.getAttribute('data-bs-dyn');
      if (k === 'name2') {
        n.textContent = f.name;
      } else if (f[k] != null) {
        n.textContent = f[k];
      }
    });

    var imgIds = ['hero', 'scene1', 'scene2', 'story', 'team', 'review'];
    imgIds.forEach(function (k) {
      var el = document.getElementById('bs-img-' + k);
      if (el && f.img && f.img[k]) el.src = f.img[k];
    });

    var kphoto = f.img && f.img.kphoto;
    var canImg = document.getElementById('bs-img-can');
    // Sticky-bar thumbnail: use the can thumb / kanna photo, else the hero
    // image (always populated) — never fall back to the brand logo.
    var canSrc = f.img && (f.img.can || f.img.kphoto || f.img.hero);
    if (canImg && canSrc) canImg.src = canSrc;
    var kannaImg = document.getElementById('bs-img-kanna');
    if (kannaImg && kphoto) {
      kannaImg.src = kphoto;
      if (f.kannaAlt) kannaImg.alt = f.kannaAlt;
    }

    var heroImg = document.getElementById('bs-img-hero');
    if (heroImg && f.heroAlt) heroImg.alt = f.heroAlt;

    var notes = document.getElementById('bs-notes');
    if (notes) {
      notes.innerHTML = '';
      (f.notes || []).forEach(function (n) {
        var s = document.createElement('span');
        s.textContent = n;
        notes.appendChild(s);
      });
    }

    document.querySelectorAll('[data-bs-atc]').forEach(function (a) {
      // Prefer AJAX add-to-cart whenever a product form exists (even when a
      // discount code is set). Keep the permalink as a no-JS href fallback so
      // the button still works if JS is unavailable.
      if (f.formId) {
        a.setAttribute('data-bs-form', f.formId);
        a.setAttribute('data-bs-mode', 'form');
        a.setAttribute('href', f.permalink || f.cart || f.fallbackUrl || '#');
      } else {
        var target = f.permalink || f.cart || f.fallbackUrl;
        if (target) {
          a.setAttribute('href', target);
          a.setAttribute('data-bs-mode', 'permalink');
        }
      }
    });

    // Subscription frequency control (if present) follows the active product's
    // plans and writes the chosen selling plan into the active flavor's form.
    syncFrequency(f);

    if (pushHash && history.replaceState) {
      try { history.replaceState(null, '', '#' + key); } catch (e) { /* ignore */ }
    }
  }

  // ---- Subscription frequency selector (custom segmented control).
  //      Rendered in the hero buy box only when the frequency block is enabled
  //      in theme settings. Backed by the product's Skio selling plans: each
  //      button carries a real selling_plan id, and selecting one writes it into
  //      the active flavor's hidden `selling_plan` input so add-to-cart from
  //      anywhere on the page (hero, sticky bar, FAQ recap) uses that frequency.
  var freqGroup = document.querySelector('[data-bs-freq-group]');

  // Short label from a Skio plan name, e.g. "Delivery every 2 weeks" -> "2 weeks".
  function freqShort(name) {
    // Longer unit spellings first so "2 weeks" keeps its "s" (ordered alternation).
    var m = String(name || '').match(/(\d+)\s*(weeks?|days?|months?)/i);
    return m ? (m[1] + ' ' + m[2].toLowerCase()) : String(name || '');
  }

  function activeForm() {
    var f = FLAVORS[state.flavor];
    return f && f.formId ? document.getElementById(f.formId) : null;
  }

  function writePlan(planId) {
    var form = activeForm();
    var input = form && form.querySelector('input[name="selling_plan"]');
    if (input) input.value = planId || '';
  }

  // Rebuild the frequency buttons for the active flavor, keeping the previously
  // chosen interval when the new flavor also offers it, else the first plan.
  function syncFrequency(f) {
    if (!freqGroup) return;
    var opts = freqGroup.querySelector('[data-bs-freq-opts]');
    var out = freqGroup.querySelector('[data-bs-freq-out]');
    var plans = (f && f.plans) || [];
    if (!opts) return;
    // Dedupe intervals Skio can expose more than once (e.g. the same frequency
    // across multiple selling-plan groups) so each interval shows a single button.
    var seen = {};
    plans = plans.filter(function (p) {
      var label = freqShort(p.name);
      if (seen[label]) return false;
      seen[label] = true;
      return true;
    });
    if (!plans.length) {
      // No subscription plans for this product → hide the control, one-time buy.
      freqGroup.setAttribute('hidden', '');
      opts.innerHTML = '';
      writePlan('');
      return;
    }
    freqGroup.removeAttribute('hidden');
    var prevLabel = out ? out.textContent : '';
    var chosen = null;
    plans.forEach(function (p) { if (freqShort(p.name) === prevLabel) chosen = p; });
    if (!chosen) chosen = plans[0];
    opts.innerHTML = '';
    plans.forEach(function (p) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-bs-freq', '');
      b.setAttribute('data-plan-id', p.id);
      b.setAttribute('aria-pressed', p === chosen ? 'true' : 'false');
      b.textContent = freqShort(p.name);
      opts.appendChild(b);
    });
    if (out) out.textContent = freqShort(chosen.name);
    writePlan(chosen.id);
  }

  // Frequency button clicks (delegated — buttons are rebuilt on each switch).
  if (freqGroup) {
    freqGroup.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-bs-freq]');
      if (!btn) return;
      freqGroup.querySelectorAll('[data-bs-freq]').forEach(function (x) {
        x.setAttribute('aria-pressed', x === btn ? 'true' : 'false');
      });
      var out = freqGroup.querySelector('[data-bs-freq-out]');
      if (out) out.textContent = btn.textContent;
      writePlan(btn.getAttribute('data-plan-id'));
    });
  }

  // Flavor pills switch the whole page to the selected product in place — no
  // navigation. (They render as #handle anchors so a shared link still opens on
  // the right product and the no-JS fallback stays harmless.)
  document.querySelectorAll('.bs-flav [data-flav]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      var key = b.getAttribute('data-flav');
      if (!key || !FLAVORS[key]) return; // unknown flavor → let the link behave normally
      e.preventDefault();
      setFlavor(key, true);
    });
  });

  // ---- Toast on email capture submit
  var toastEl = document.getElementById('bs-toast');
  var toastT;
  var capForm = document.getElementById('bs-capform');
  if (capForm && toastEl) {
    capForm.addEventListener('submit', function (e) {
      e.preventDefault();
      toastEl.textContent = toastEl.getAttribute('data-success-text') || 'You’re on the list.';
      toastEl.setAttribute('data-show', 'true');
      clearTimeout(toastT);
      toastT = setTimeout(function () {
        toastEl.setAttribute('data-show', 'false');
      }, 2600);
      e.target.reset();
    });
  }

  // ---- Sticky bottom ATC bar visibility
  var bar = document.getElementById('bs-stickybar');
  var sentinel = document.querySelector('.bs-buybox [data-bs-atc]');
  if (bar && sentinel) {
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.setAttribute('data-show', entries[0].isIntersecting ? 'false' : 'true');
      }, { rootMargin: '-60px 0px 0px 0px' }).observe(sentinel);
    } else {
      bar.setAttribute('data-show', 'true');
    }
  }

  // ---- CTA submits active flavor's product form via AJAX (unless it's a permalink).
  //      Mirrors the pattern in sections/subscription.liquid so Skio selling plans
  //      and the theme's cart drawer work the same way.
  async function submitActiveForm(cta) {
    var mode = cta.getAttribute('data-bs-mode');
    if (mode === 'permalink') return false; // let the browser follow the href
    var formId = cta.getAttribute('data-bs-form');
    var form = formId ? document.getElementById(formId) : null;
    if (!form) return false;

    if (cta.getAttribute('aria-busy') === 'true') return true;
    cta.setAttribute('aria-busy', 'true');

    try {
      // Apply the flavor's discount first (shareable link) so the cart — and
      // the cart drawer that re-renders from it — reflects the discounted price
      // and the code carries to checkout. Best-effort.
      var activeFlavor = FLAVORS[state.flavor];
      if (activeFlavor && activeFlavor.discountCode) {
        try { await fetch('/discount/' + encodeURIComponent(activeFlavor.discountCode), { redirect: 'follow' }); } catch (e) { /* best-effort */ }
      }

      var formData = new FormData(form);

      // Prefer Skio-managed selling_plan if its hidden input exists in the form.
      var skioPlan = form.querySelector('input[name="selling_plan"]');
      var planVal = String(skioPlan && skioPlan.value || '').trim();
      if (planVal) formData.set('selling_plan', planVal);
      else formData.delete('selling_plan');

      var sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
        .map(function (el) { return el.getAttribute('data-section-id'); })
        .filter(Boolean);
      if (sectionIds.length) {
        formData.set('sections', sectionIds.join(','));
        formData.set('sections_url', window.location.pathname);
      }

      var cartAddUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
      var response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-Brightside-Cart-Upsell': '1'
        },
        body: formData
      });

      var result = await response.json();
      if (result.status && result.message) {
        throw new Error(result.description || result.message);
      }

      var itemCount = 1;
      try {
        var cartResponse = await fetch('/cart.js');
        var cart = await cartResponse.json();
        if (typeof cart.item_count === 'number') itemCount = cart.item_count;
      } catch (e) { /* ignore */ }

      try {
        var mod = await import('@theme/events');
        if (mod && mod.CartAddEvent) {
          document.dispatchEvent(new mod.CartAddEvent(result, form.id, {
            source: 'brightside-hero',
            itemCount: itemCount,
            variantId: String(formData.get('id') || ''),
            sections: result.sections || {}
          }));
        }
      } catch (e) { /* theme events import optional */ }

      // Open the theme's native cart drawer (rendered on these pages by the
      // brightside-cart-drawer section). It re-rendered above via CartAddEvent.
      var cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
    } catch (err) {
      console.error('Brightside hero add-to-cart failed:', err);
      // On failure, fall back to permalink / fallback URL if we have one.
      var fallback = cta.getAttribute('href');
      if (fallback && fallback !== '#') window.location.href = fallback;
    } finally {
      cta.removeAttribute('aria-busy');
    }
    return true;
  }

  document.addEventListener('click', function (e) {
    var cta = e.target.closest && e.target.closest('[data-bs-atc]');
    if (!cta) return;
    var mode = cta.getAttribute('data-bs-mode');
    if (mode === 'permalink') return; // native navigation to /cart/VAR:1?discount=CODE
    if (mode !== 'form') return; // only intercept when we have a form to submit
    e.preventDefault();
    submitActiveForm(cta);
  });

  // ---- Initial flavor from hash (if valid)
  var initial = (location.hash || '').replace('#', '');
  setFlavor(FLAVORS[initial] ? initial : state.flavor, false);
})();
